import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3139d4ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn_tool btn_tool-small" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M855.98208 847.74912H170.06592c-40.77568 0-73.9328-33.1776-73.9328-73.95328 0-56.66816 31.66208-107.27424 82.6368-132.096 9.5232-4.62848 15.42144-13.59872 15.42144-23.40864v-148.25472c0-127.61088 75.5712-242.3808 192.67584-292.864-0.04096-1.16736-0.04096-2.3552-0.04096-3.54304 0-33.73056 14.15168-66.27328 38.8096-89.2928 24.65792-22.99904 58.14272-34.87744 91.91424-32.52224 61.27616 4.23936 109.99808 53.71904 113.31584 115.0976 0.12288 2.29376 0.18432 4.58752 0.18432 6.90176 58.368 23.26528 108.17536 62.91456 144.11776 114.72896 37.08928 53.4528 56.68864 116.224 56.68864 181.49376v148.25472c0 9.80992 5.91872 18.78016 15.42144 23.40864 50.97472 24.82176 82.6368 75.44832 82.6368 132.096 0 40.79616-33.1776 73.95328-73.9328 73.95328z m-677.45792-81.92h668.99968c-2.64192-21.77024-15.9744-40.67328-36.10624-50.46272-37.92896-18.47296-61.48096-55.66464-61.48096-97.05472v-148.25472c0-48.51712-14.5408-95.1296-42.06592-134.81984-26.9312-38.83008-64.3072-68.46464-108.07296-85.68832-30.96576-12.20608-51.34336-42.35264-50.66752-75.03872 0.02048-1.06496 0-2.08896-0.04096-3.13344-1.08544-19.84512-17.408-36.4544-37.1712-37.80608-11.34592-0.77824-22.13888 3.01056-30.35136 10.69056-8.25344 7.70048-12.77952 18.1248-12.77952 29.3888 0 0.53248 0.02048 1.06496 0.04096 1.57696 1.31072 33.56672-17.67424 63.67232-48.35328 76.71808-87.6544 37.2736-144.30208 122.88-144.30208 218.112v148.25472c0 41.41056-23.552 78.60224-61.48096 97.05472-20.21376 9.80992-33.54624 28.69248-36.16768 50.46272zM394.91584 899.05152c20.52096 42.2912 63.85664 71.45472 114.03264 71.45472 50.15552 0 93.51168-29.16352 114.03264-71.45472H394.91584z",
  fill: "currentColor",
  "p-id": "12806"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { MessageService } from '@/services/message.service'
import { onUnmounted, ref } from 'vue'
import MessageDetails from '@/views/_components/message-details/message-details.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'unread-count',
  setup(__props) {

const injector = useReflectiveInjector()
const messageService = injector.get(MessageService)

const unreadCount = ref(messageService.unreadCount)
let unreadCountSubject
const messageDetailsVisible = ref(false)

unreadCountSubject = messageService.unreadCountSubject.subscribe((count) => {
  unreadCount.value = count
})

function handleClick () {
  messageService.closeAllNotifications()
  messageService.clearUnreadCount()
  messageDetailsVisible.value = true
}

onUnmounted(() => {
  unreadCountSubject.unsubscribe()
})

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_badge, {
      value: unreadCount.value,
      hidden: !unreadCount.value,
      max: 10,
      class: "item",
      type: "danger"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createElementBlock("svg", {
            t: "1778484776155",
            onClick: handleClick,
            class: "icon",
            viewBox: "0 0 1024 1024",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "p-id": "12805",
            width: "21",
            height: "21"
          }, _hoisted_3))
        ])
      ]),
      _: 1
    }, 8, ["value", "hidden"]),
    _createVNode(MessageDetails, {
      modelValue: messageDetailsVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((messageDetailsVisible).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})